<app-side-menu>
  <div class="b2b-contracts-vehicles-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <button class="btn-back" (click)="navigateBack()">
                <i class="fas fa-arrow-left"></i>
              </button>
              <h1 class="page-title">
                <i class="fas fa-motorcycle me-3"></i>
                Veículos do Contrato
              </h1>
              <p class="page-subtitle" *ngIf="contractNumber">
                Contrato: {{ contractNumber }} - {{ contractName }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="vehicles-card">
          <div *ngIf="totalItems > 0 || isLoading || searchTerm || (vehicles && vehicles.length > 0); else emptyVehicles">
            <app-table
              [title]="'Lista de Veículos (' + totalItems + ')'"
              [data]="vehicles"
              [columns]="columns"
              [loading]="isLoading"
              [clickable]="false"
              [actions]="actions"
              [showSearch]="true"
              [searchPlaceholder]="'Pesquisar placa, marca, modelo, rastreador ou pedido...'"
              [itemsPerPage]="pageSize"
              [totalItemsFromBackend]="totalItems"
              [currentPageFromBackend]="pageNumber"
              [totalPagesFromBackend]="totalPages"
              [disablePagination]="false"
              (searchChange)="onSearchChange($event)"
              (actionClick)="onActionClick($event)"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onPageSizeChange($event)">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="totalItems === 0"
                (buttonClick)="exportExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
            </app-table>
            <div *ngIf="!isLoading && searchTerm && vehicles.length === 0" class="empty-state mt-3">
              <i class="fas fa-search"></i>
              <h3>Nenhum veículo encontrado</h3>
              <p>Nenhum resultado para "{{ searchTerm }}". Tente outra placa, marca ou modelo.</p>
            </div>
          </div>

          <ng-template #emptyVehicles>
            <div class="empty-state">
              <i class="fas fa-motorcycle"></i>
              <h3>Nenhum veículo encontrado</h3>
              <p>Este contrato não possui veículos na frota.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
